export const SOFTLINE_API_DOCUMENT_NOTES =
  '/sales-document-service/sales-document-service/documents/{{id}}/notes';
export const SOFTLINE_API_DOCUMENT_NOTE_BY_ID =
  '/sales-document-service/sales-document-service/documents/{{id}}/notes/{{noteId}}';
export const SOFTLINE_API_DOCUMENT_PREVIEW =
  '/sales-document-service/sales-document-service/documents/{{id}}/preview';
export const SOFTLINE_API_DOCUMENTS_PREVIEW =
  '/sales-document-service/sales-document-service/documents/preview';
/** Catalog of Belegvermerk categories — the `categoryKey` a note may carry.
    Not scoped to a document, so it is fetched once and reused. */
export const SOFTLINE_API_DOCUMENT_NOTE_CATEGORIES =
  '/sales-document-service/sales-document-service/meta/document-note-categories';
